module.exports = __webpack_public_path__ + "img/bg.c4277e04.jpg";